<template>
  <div :class="classes">
    <div class="row row--margin-bottom-10 hidden-lg">
      <div class="col-xs-8">
        <h3 class="option-product-checkbox__retail-name">{{ packageOptionProduct.ProductRetailName }}</h3>
      </div>
      <div class="col-xs-4">
        <div class="toggle-button-wrapper">
          <button
            :disabled="optionProductIsDisabled"
            type="button"
            class="button toggle-button__button"
            @click="handleToggleOptionBtnClick"
          >
            <i
              v-if="showCtaIcon"
              :class="iconClasses"
              aria-hidden="true"
            />
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
    <div class="row row--margin-bottom-10 visible-lg">
      <div class="col-lg-6">
        <h3 class="option-product-checkbox__retail-name">{{ packageOptionProduct.ProductRetailName }}</h3>
      </div>
      <div class="col-lg-3">
        <option-cost
          :package-base-cost="offerPackage.EffectiveCost"
          :cost="packageOptionProduct.Cost"
          :show-as-total="packageOptionProduct.ShowAsTotal"
          :is-per-frame="isPerFrame"
          :show-modifier="packageOptionProduct.Cost > 0"
          class="option-product-checkbox__price option-product-checkbox__price--margin-top"
        />
      </div>
      <div class="col-lg-3">
        <div class="toggle-button-wrapper">
          <button
            :disabled="optionProductIsDisabled"
            type="button"
            class="button toggle-button__button"
            @click="handleToggleOptionBtnClick"
          >
            <i
              v-if="showCtaIcon"
              :class="iconClasses"
              aria-hidden="true"
            />
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="packageOptionProduct.ProductRetailDescription.length > 0 || selectedLetterJacketOption"
      class="row row--margin-bottom-10"
    >
      <div class="col-xs-12">
        <div
          v-if="selectedLetterJacketOption === null"
          class="option-product-checkbox__retail-description"
        >
          {{ packageOptionProduct.ProductRetailDescription }}
        </div>
        <div
          v-if="selectedLetterJacketOption"
          class="option-product-checkbox__selected-option-name"
        >
          Selected: {{ selectedLetterJacketOptionName }}
        </div>
      </div>
    </div>
    <div class="row hidden-lg">
      <div class="col-xs-12">
        <option-cost
          :package-base-cost="offerPackage.EffectiveCost"
          :cost="packageOptionProduct.Cost"
          :show-as-total="packageOptionProduct.ShowAsTotal"
          :is-per-frame="isPerFrame"
          :show-modifier="packageOptionProduct.Cost > 0"
          class="option-product-checkbox__price"
        />
      </div>
    </div>
    <input
      v-if="optionProductIsSelected"
      :value="packageOptionInputValue"
      :name="packageOptionInputName"
      type="hidden"
    >
    <div v-if="showSelectedLetterJacketOptionInput">
      <input
        :name="selectedLetterJacketOptionNameInputName"
        :value="selectedLetterJacketOption.Name"
        type="hidden"
      >
      <input
        :name="selectedLetterJacketOptionSkuInputName"
        :value="selectedLetterJacketOption.SKU"
        type="hidden"
      >
      <input
        :name="selectedLetterJacketOptionRetailNameInputName"
        :value="selectedLetterJacketOption.RetailName"
        type="hidden"
      >
      <input
        :name="selectedLetterJacketOptionContentfulIdInputName"
        :value="selectedLetterJacketOption.Id"
        type="hidden"
      >
    </div>
    <letter-jacket-option-modal
      v-if="hasLetterJacketOptions"
      v-show="showLetterJacketOptionModal"
      :product-retail-name="packageOptionProduct.ProductRetailName"
      :options="packageOptionProduct.CmsLetterJacketProductOptions"
      @modal-close="showLetterJacketOptionModal = false"
      @option-selected="handleLetterJacketOptionSelected"
    />
  </div>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'
import OptionCost from '@Shared/components/catalog/PackageOption/OptionCost'
import LetterJacketOptionModal from './LetterJacketOptionModal'

import { find } from 'lodash'

export default {
  name: 'OptionProductCheckbox',
  components: {
    LetterJacketOptionModal,
    OptionCost
  },
  props: {
    catalogPackageOptionId: { type: Number, default: null, required: true },
    isPerFrame: { type: Boolean, default: false, required: true },
    optionIndex: { type: Number, default: 0, required: true },
    packageOptionProduct: { type: Object, default: null, required: true },
    productIndex: { type: Number, default: 0, required: true }
  },
  data () {
    return {
      selectedLetterJacketOption: null,
      showLetterJacketOptionModal: false
    }
  },
  computed: {
    classes () {
      return {
        'option-product-checkbox': true,
        'option-product-checkbox--disabled': this.optionProductIsDisabled
      }
    },
    optionProductIsSelected () {
      return this.$store.getters.getOptionProductIsSelected(this.packageOptionProduct)
    },
    optionProductIsConfigured () {
      return this.$store.getters.getConfiguredValue(this.packageOptionInputName, this.packageOptionProduct.CatalogPackageOptionProductID) !== null
    },
    optionProductIsDisabled () {
      return this.$store.getters.getOptionProductIsDisabled(this.packageOptionProduct)
    },
    offerPackage () {
      return this.$store.state.catalogPageCommon.offerPackage
    },
    firstOptionProduct () {
      return this.$store.state.catalogPageCommon.firstOptionProduct
    },
    packageOptionInputName () {
      return `OptionProductIDForPackageOption_${this.catalogPackageOptionId}`
    },
    packageOptionInputValue () {
      return this.packageOptionProduct.CatalogPackageOptionProductID
    },
    selectedLetterJacketOptionNameInputName () {
      return `Name_${this.packageOptionProduct.CatalogPackageOptionProductID}`
    },
    selectedLetterJacketOptionSkuInputName () {
      return `SKU_${this.packageOptionProduct.CatalogPackageOptionProductID}`
    },
    selectedLetterJacketOptionRetailNameInputName () {
      return `RetailName_${this.packageOptionProduct.CatalogPackageOptionProductID}`
    },
    selectedLetterJacketOptionContentfulIdInputName () {
      return `ContentfulId_${this.packageOptionProduct.CatalogPackageOptionProductID}`
    },
    selectedPatch () {
      return this.$store.state.letterJackets.selectedPatch
    },
    iconClasses () {
      return {
        'fa': true,
        'fa-minus': this.optionProductIsSelected,
        'fa-plus': !this.optionProductIsSelected
      }
    },
    buttonText () {
      if (this.optionProductIsSelected === true) {
        return 'Remove'
      } else {
        if (this.hasLetterJacketOptions) {
          return 'Select'
        } else {
          return 'Add'
        }
      }
    },
    hasLetterJacketOptions () {
      return this.packageOptionProduct.CmsLetterJacketProductOptions !== null && this.packageOptionProduct.CmsLetterJacketProductOptions.length > 0
    },
    zOrder () {
      return this.optionIndex + this.productIndex
    },
    showCtaIcon () {
      return !this.hasLetterJacketOptions
    },
    selectedLetterJacketOptionName () {
      if (this.selectedLetterJacketOption === null) {
        return null
      }

      if (this.selectedLetterJacketOption.RetailName !== null) {
        return this.selectedLetterJacketOption.RetailName
      }

      return this.selectedLetterJacketOption.Name
    },
    showSelectedLetterJacketOptionInput () {
      return this.optionProductIsSelected && this.selectedLetterJacketOption
    },
    configuredLetterJacketOptionId () {
      return this.$store.getters.getConfiguredValue(this.selectedLetterJacketOptionContentfulIdInputName)
    }
  },
  watch: {
    selectedPatch (v, ov) {
      this.removeOptionProduct()
    },
    optionProductIsSelected (v, ov) {
      if (v === false && ov === true) {
        this.selectedLetterJacketOption = null
      }
    },
    optionProductIsDisabled (v, ov) {
      if (v === true && this.optionProductIsSelected === true) {
        this.removeOptionProduct()
      }
    }
  },
  mounted () {
    if (this.optionProductIsConfigured && !this.hasLetterJacketOptions) {
      this.addOptionProduct() // if no letter jacket options can just add the product
    } else if (this.optionProductIsConfigured && this.hasLetterJacketOptions) {
      if (this.configuredLetterJacketOptionId !== null) {
        const selectedLetterJacketOption = find(this.packageOptionProduct.CmsLetterJacketProductOptions, { 'Id': this.configuredLetterJacketOptionId })

        if (selectedLetterJacketOption !== null) {
          this.addOptionProduct() // only add the product if the related letter jacket option is found
          this.selectedLetterJacketOption = selectedLetterJacketOption
        }
      }
    }
  },
  methods: {
    handleToggleOptionBtnClick () {
      GoogleAnalytics.trackEvent(
        'Option Product Toggle',
        'click',
        this.packageOptionProduct.ProductName
      )

      if (this.optionProductIsSelected === false) {
        if (this.hasLetterJacketOptions) {
          this.showLetterJacketOptionModal = true
        } else {
          this.addOptionProduct()
        }
      } else {
        this.removeOptionProduct()
      }
    },
    removeOptionProduct () {
      this.selectedLetterJacketOption = null
      this.$store.dispatch('removeSelectedOptionProduct', { packageOptionProduct: this.packageOptionProduct })
    },
    handleLetterJacketOptionSelected (option) {
      this.selectedLetterJacketOption = option
      this.addOptionProduct()
      this.showLetterJacketOptionModal = false
    },
    addOptionProduct () {
      this.$store.dispatch('addSelectedOptionProduct', { optionProduct: this.packageOptionProduct, zOrder: this.zOrder })
    }
  }
}
</script>

<style scoped lang="scss">
@import './scss/option-product.scss';

.option-product-checkbox {
  @include option-product-mixin;

  &__retail-name {
    margin-top: 8px;
  }

  &__selected-option-name {
    background-color: #5fb630;
    color: #fff;
    display: inline-block;
    font-size: 16px;
    font-weight: 600;
    line-height: 1em;
    padding: 5px 10px;
    text-align: center;
    width: 100%;
  }

  @media screen and (min-width: $screen-lg-min) {
    &__selected-option-name {
      text-align: left;
      width: auto;
    }
  }
}

.toggle-button {
  &__button {
    font-size: 14px;
    font-weight: normal;

    &:disabled {
      border-color: #999;
      color: #999;
      cursor: not-allowed;

      &:hover,
      &:focus {
        outline: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/PackageOptions/OptionProduct/OptionProductCheckbox.vue